import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { EditorialSplit } from "@/components/EditorialSplit";
import { FlashSale } from "@/components/FlashSale";
import { NewArrivals } from "@/components/NewArrivals";
import { FeaturedProducts } from "@/components/FeaturedProducts";
import { CategoryGrid } from "@/components/CategoryGrid";
import { BrandSpotlight } from "@/components/BrandSpotlight";
import { Footer } from "@/components/Footer";
import { NavLink } from "react-router-dom";

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />
      <main className="flex-1">
        {/* Mobile: hero compatto a singola immagine. Desktop: split editoriale Donna/Uomo. */}
        <div className="md:hidden">
          <Hero />
        </div>
        <div className="hidden md:block">
          <EditorialSplit />
        </div>
        <Marquee />
        <FlashSale />
        <NewArrivals />
        <FeaturedProducts />

        {/* Statement strip */}
        <section className="bg-stone-950 py-14 md:py-24">
          <div className="max-w-5xl mx-auto px-6 text-center">
            <p className="text-emerald-400 text-[10px] sm:text-[11px] tracking-[0.3em] uppercase font-semibold mb-4 md:mb-6">
              Brand internazionali · Prezzi outlet
            </p>
            <h2
              className="text-white leading-[1.05] mb-4 md:mb-6 font-semibold md:font-bold"
              style={{ fontSize: "clamp(1.5rem, 5vw, 4rem)", letterSpacing: "-0.03em" }}
            >
              Un'unica destinazione
            </h2>
            <p className="text-stone-400 text-sm md:text-lg max-w-xl mx-auto mb-6 md:mb-10 leading-relaxed">
              Per il meglio della moda a prezzi outlet.
            </p>
            <NavLink
              to="/shop"
              className="inline-flex items-center gap-2 border border-white/30 text-white text-[10px] sm:text-[11px] tracking-[0.25em] uppercase px-8 sm:px-12 py-3 sm:py-4 hover:bg-white hover:text-stone-900 transition-all duration-200 font-semibold"
            >
              Scopri la collezione
            </NavLink>
          </div>
        </section>

        <CategoryGrid />
        <BrandSpotlight />
      </main>
      <Footer />
    </div>
  );
}
